
import _ from 'lodash';

const BaseForm = {

    data() {
        return {
            saveProgress: true,
            saveStatus: '',
            isLoading: false,
            processing: false
        }
    },
    props: {
        'action': {
            type: String,
            required: true
        },

        'data': {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    created: function() {
        // console.log('orig BaseForm created');

        // console.warn(this);
        // if (!!this.locales && this.locales.length > 0) {
        let form = this.form
        // this.locales.map(function(l) {
        //     if (!_.has(form, l)) {
        //         _.set(form, l, {})
        //     }
        // })
        // this.currentLocale = this.defaultLocale;
        // }

        //FIXME: now we can't add dynamic input in update type of form
        if (!_.isEmpty(this.data)) {
            this.form = this.data;
        }

        // window.addEventListener('resize', this.onResize);
    },
    data: function() {
        return {
            form: {

            },

        }
    },

    methods: {
        getPostData() {
            if(this.mediaCollections) {
                this.mediaCollections.forEach((collection, index, arr)=>{
                    if(this.form[collection]) {
                        console.warn("MediaUploader warning: Media input must have a unique name, '"+collection+"' is already defined in regular inputs.");
                    }

                    if(this.$refs[collection+'_uploader']) {
                        this.form[collection] = this.$refs[collection+'_uploader'].getFiles();
                    }
                });
            }

            return this.form;
        },
        onSubmit() {
            if (this.processing === true) {
                return;
            }
            console.log('onsubmit');
            return this.$validator.validateAll()
            .then(result => {

                if (!result) {
                    // console.log('submit hibas form');
                    // console.log(result);
                    this.$notify({ type: 'error', title: 'Error!', text: 'The form contains invalid fields.'});
                    return false;
                }
                // this.form['g-recaptcha-response'] = getReCaptchaV3Response('registration_id');
                // var data = this.form;
                // if (!this.sendEmptyLocales) {
                // data = _.omit(this.form, this.locales.filter(locale => _.isEmpty(this.form[locale])));
                // data = _.omit(this.form);
                // }
                // console.log(this.form.city);
                // console.log(this.form);
                this.processing = true;
                // this.form.set('_method', 'post');
                // this.$http.post(this.action, this.form )
                // NOTE: KIVETTEM, mert nem tudni miert kell ez.
                // if (!_.isEmpty(this.data)) {
                //     this.form = this.data;
                //
                // }
                let loader = this.$loading.show();
                // this.saveProgress = true;
                axios.post(this.action, this.form )
                .then(response => {
                    // console.warn('response:');
                    // console.warn(response);
                    this.$refs.captcha.execute();
                    loader.hide();
                    // this.saveProgress = false;
                    // this.saveStatus = true;
                    // setTimeout(() => { this.saveStatus = '' }, 2000)
                    this.onSuccess(response.data );
                })
                .catch(errors => {
                    this.$refs.captcha.execute();
                    console.log('catch errors:');
                    console.log(errors);
                    // this.saveProgress = false;
                    // this.saveStatus = false;
                    this.onFail(errors.response.data.errors);
                    loader.hide();
                })
            });
        },
        onSuccess(data) {
            console.log('.onSuccess()');
            this.processing = false;
            console.log(data);
            if (data.redirect) {
                window.location.replace(data.redirect)
            }

            if (data.error) {
                // console.log('data.errors');
                // console.log(data.errors);
                this.error = data.error;
                this.$notify({
                    'type': 'error',
                    group: 'appnotif',
                    title: 'Adatok mentése',
                    text: 'A mentés nem sikerült!'
                });
                // this.errors = data.errors
            } else {
                if (data.success) {
                    this.success = data.success;
                    this.$notify({
                        'type': 'success',
                        group: 'appnotif',
                        title: 'Adatok mentése',
                        text: 'A mentés sikerült!'
                    });

                }
            }
        },
        onFail(errors) {
            console.warn('onfail.errors()');
            console.warn(errors);
            this.$notify({
                'type': 'error',
                group: 'appnotif',
                title: 'Adatok mentése',
                text: 'Hiba az adatok mentése közben, a mentés nem sikerült!'
            });
            this.processing = false;
            var bag = this.$validator.errors;
            console.warn('bag');
            console.warn(bag);
            Object.keys(errors).map(function(key) {
                console.log(key);
                var splitted = key.split('.', 2);
                console.log(splitted);
                // we assume that first dot divides column and locale (TODO maybe refactor this and make it more general)
                if (splitted.length > 1) {
                    bag.add(splitted[0]+'_'+splitted[1], errors[key][0]);
                } else {
                    // bag.add(key, errors[key][0]);
                    bag.add({ field: key, msg: errors[key][0] })
                }
            });
        }

    }

}
export default BaseForm
